import type { CarOrderDetailResponse } from "@/api/car";

type CarOrderData = CarOrderDetailResponse["data"];

type Props = {
  fee: CarOrderData["fee"];
  insurance: CarOrderData["insurance"];
};

export default function CarFeeSection({ fee, insurance }: Props) {
  return (
    <div className="mx-4 mt-3 bg-white rounded-2xl overflow-hidden">
      <div className="w-full flex items-center justify-between px-4 py-3.5">
        <span className="text-sm font-bold text-gray-900">费用明细</span>
        <span className="font-bold text-base" style={{ color: "#EF4444" }}>
          ¥{Number(fee?.total_amount ?? 0).toFixed(2)}
        </span>
      </div>
      <div
        className="px-4 pb-4 space-y-2 text-xs"
        style={{ borderTop: "1px solid #F5F5F5" }}
      >
        {[
          ["日租金", `¥${fee?.daily_price ?? "0"}`],
          ["车辆租金", `¥${fee?.car_amount ?? "0"}`],
          ["保险", `¥${insurance?.price ?? "0"}（${insurance.type_text}）`],
          [
            "押金说明",
            fee?.deposit_amount && fee.deposit_amount !== "0.00"
              ? `现金押金¥${fee.deposit_amount}`
              : (fee?.deposit_type_text ?? "—"),
          ],
        ].map(([a, b]) => (
          <div key={String(a)} className="flex justify-between text-gray-600">
            <span>{a}</span>
            <span className="font-medium text-gray-800">{b}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
